var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { InviteUserView } from './View';
import { useUser } from 'context';
function generateRandomName() {
    var firstNames = ['John', 'Jane', 'Sam', 'Sally', 'Bob', 'Alice'];
    var lastNames = ['Smith', 'Doe', 'Johnson', 'Brown', 'Taylor', 'Miller'];
    var randomFirstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    var randomLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    return {
        firstName: randomFirstName,
        lastName: randomLastName,
    };
}
export var InviteUserContainer = function () {
    var _a = useUser(), account = _a.account, switchAccount = _a.switchAccount;
    var onSubmit = function (_a) {
        var email = _a.email, role = _a.role;
        return __awaiter(void 0, void 0, void 0, function () {
            var validId, newUserId, userExists, _b, firstName, lastName, updatedAccount;
            var _c;
            return __generator(this, function (_d) {
                validId = false;
                while (!validId) {
                    newUserId = "U-".concat(Math.floor(Math.random() * (9999999 - 1000000) + 1000000), "-DEV");
                    userExists = (_c = account === null || account === void 0 ? void 0 : account.users) === null || _c === void 0 ? void 0 : _c.find(function (u) { return u.userId === newUserId; });
                    if (!userExists) {
                        validId = true;
                    }
                }
                _b = generateRandomName(), firstName = _b.firstName, lastName = _b.lastName;
                updatedAccount = __assign(__assign({}, account), { users: __spreadArray(__spreadArray([], __read(account.users), false), [
                        {
                            role: role,
                            user: {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                hasAcceptedTerms: false,
                            },
                            userId: newUserId,
                        },
                    ], false) });
                switchAccount(updatedAccount);
                localStorage.setItem(account.id, JSON.stringify(updatedAccount));
                return [2, { email: email, role: role }];
            });
        });
    };
    return (React.createElement(InviteUserView, { onSubmit: onSubmit, loading: false, facility: account.facilities.filter(function (f) { return (f === null || f === void 0 ? void 0 : f.status) === 'ACTIVE'; }) }));
};
